export default "__VITE_ASSET__Dy4j_8cj__"